import type { ProviderFieldSpec } from './providers';

type Props = {
  spec: ProviderFieldSpec;
  value: string;
  error: string | undefined;
  onChange: (value: string) => void;
};

export function PixelField({ spec, value, error, onChange }: Props) {
  const id = `tracking-${spec.name}`;
  const errorId = `${id}-error`;
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="text-[12px] font-medium text-[var(--co-text)]">
        {spec.label}
        {spec.optional && <span className="font-normal text-[var(--co-muted)]"> (optional)</span>}
      </label>
      <input
        id={id}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={spec.placeholder}
        spellCheck={false}
        autoComplete="off"
        aria-invalid={error !== undefined}
        aria-describedby={error ? errorId : undefined}
        className="rounded-lg border border-[var(--co-border)] bg-transparent px-3 py-2 font-mono text-[13px] text-[var(--co-text)] outline-none focus:border-[var(--co-brand)] aria-[invalid=true]:border-[var(--co-error)]"
      />
      {error && (
        <span id={errorId} className="text-[11px] text-[var(--co-error)]">
          {error}
        </span>
      )}
    </div>
  );
}
